import React from "react";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Form, Input, Space, Checkbox } from "antd";

const Map = () => {
  // const options = [
  //   { label: "2 Stories", value: "2 Stories" },
  //   { label: "24/7 Security", value: "24/7 Security" },
  //   { label: "26' Ceilings", value: "26' Ceilings" },
  //   { label: "Activity Lawn", value: "Activity Lawn" },
  //   { label: "Balcony", value: "Balcony" },
  //   { label: "BBQ Area", value: "BBQ Area" },
  //   { label: "Bike Path", value: "Bike Path" },
  //   { label: "Central Cooling", value: "Central Cooling" },
  //   { label: "Central Heating", value: "Central Heating" },
  //   { label: "Children's Play Area", value: "Children's Play Area" },
  //   { label: "Dual Sinks", value: "Dual Sinks" },
  //   { label: "Electric Range", value: "Electric Range" },
  //   { label: "Emergency Exit", value: "Emergency Exit" },
  //   { label: "Entry Court", value: "Entry Court" },
  //   { label: "Event Zone", value: "Event Zone" },
  //   { label: "Fire Alarm", value: "Fire Alarm" },
  //   { label: "Fire Place", value: "Fire Place" },
  //   { label: "Gym", value: "Gym" },
  //   { label: "Health Club", value: "Health Club" },
  //   { label: "Home Theater", value: "Home Theater" },
  //   { label: "Hurricane Shutters", value: "Hurricane Shutters" },
  //   { label: "Jog Path", value: "Jog Path" },
  //   { label: "Jogging Track", value: "Jogging Track" },
  //   { label: "Kid’s Wet & Dry Area", value: "Kid’s Wet & Dry Area" },
  //   { label: "Kids Pool", value: "Kids Pool" },
  //   { label: "Landscape Plaza", value: "Landscape Plaza" },
  //   { label: "Landscaped Gardens", value: "Landscaped Gardens" },
  //   { label: "Laundry Room", value: "Laundry Room" },
  //   { label: "Lawn", value: "Lawn" },
  //   { label: "Main Pool", value: "Main Pool" },
  //   { label: "Marble Floors", value: "Marble Floors" },
  //   { label: "Next to Busy Way", value: "Next to Busy Way" },
  //   { label: "Outdoor Gym", value: "Outdoor Gym" },
  //   { label: "Parking", value: "Parking" },
  //   { label: "Patio Seating", value: "Patio Seating" },
  //   { label: "Pool Patio", value: "Pool Patio" },
  //   { label: "Seating Area", value: "Seating Area" },
  //   { label: "Shared Gym", value: "Shared Gym" },
  //   { label: "Shared Pool", value: "Shared Pool" },
  //   { label: "Sunken Lawn", value: "Sunken Lawn" },
  //   { label: "Swimming Pool", value: "Swimming Pool" },
  //   { label: "Tennis Court", value: "Tennis Court" },
  //   { label: "View of Water", value: "View of Water" },
  //   // CRM features
  //   { label: "Balcony", value: "Balcony" },
  //   { label: "Built in wardrobes", value: "Built in wardrobes" },
  //   { label: "Central air conditioning", value: "Central air conditioning" },
  //   { label: "Central heating", value: "Central heating" },
  //   { label: "Concierge Service", value: "Concierge Service" },
  //   { label: "Covered parking", value: "Covered parking" },
  //   { label: "Fully fitted kitchen", value: "Fully fitted kitchen" },
  //   { label: "Jacuzzi", value: "Jacuzzi" },
  //   { label: "Kitchen Appliances", value: "Kitchen Appliances" },
  //   { label: "Maid Service", value: "Maid Service" },
  //   { label: "Maid's room", value: "Maid's room" },
  //   { label: "Maids Room", value: "Maids Room" },
  //   { label: "Pets allowed", value: "Pets allowed" },
  //   { label: "Private garden", value: "Private garden" },
  //   { label: "Private Gym", value: "Private Gym" },
  //   { label: "Private swimming pool", value: "Private swimming pool" },
  //   { label: "Security", value: "Security" },
  //   { label: "Shared Gym", value: "Shared Gym" },
  //   { label: "Shared swimming pool", value: "Shared swimming pool" },
  //   { label: "Spa", value: "Spa" },
  //   { label: "Study", value: "Study" },
  //   { label: "view of landmark", value: "view of landmark" },
  //   { label: "View of sea/water", value: "View of sea/water" },
  //   { label: "Walk-in Closet", value: "Walk-in Closet" },
  //   // CRM fratures 2
  //   { label: "Covered parking", value: "Covered parking" },
  //   { label: "Fully fitted kitchen", value: "Fully fitted kitchen" },
  //   { label: "Pets allowed", value: "Pets allowed" },
  //   { label: "Private Gym", value: "Private Gym" },
  //   { label: "Swimming pool", value: "Swimming pool" },
  //   { label: "View of sea/water", value: "View of sea/water" },
  // ];
  const options = [
    { label: "2 Stories", value: "2 Stories" },
    { label: "24/7 Security", value: "24/7 Security" },
    { label: "26' Ceilings", value: "26' Ceilings" },
    { label: "Activity Lawn", value: "Activity Lawn" },
    { label: "Balcony", value: "Balcony" },
    { label: "BBQ Area", value: "BBQ Area" },
    { label: "Bike Path", value: "Bike Path" },
    { label: "Central Cooling", value: "Central Cooling" },
    { label: "Central Heating", value: "Central Heating" },
    { label: "Children's Play Area", value: "Children's Play Area" },
    { label: "Dual Sinks", value: "Dual Sinks" },
    { label: "Electric Range", value: "Electric Range" },
    { label: "Emergency Exit", value: "Emergency Exit" },
    { label: "Entry Court", value: "Entry Court" },
    { label: "Event Zone", value: "Event Zone" },
    { label: "Fire Alarm", value: "Fire Alarm" },
    { label: "Fire Place", value: "Fire Place" },
    { label: "Gym", value: "Gym" },
    { label: "Health Club", value: "Health Club" },
    { label: "Home Theater", value: "Home Theater" },
    { label: "Hurricane Shutters", value: "Hurricane Shutters" },
    { label: "Jog Path", value: "Jog Path" },
    { label: "Jogging Track", value: "Jogging Track" },
    { label: "Kid’s Wet & Dry Area", value: "Kid’s Wet & Dry Area" },
    { label: "Kids Pool", value: "Kids Pool" },
    { label: "Landscape Plaza", value: "Landscape Plaza" },
    { label: "Landscaped Gardens", value: "Landscaped Gardens" },
    { label: "Laundry Room", value: "Laundry Room" },
    { label: "Lawn", value: "Lawn" },
    { label: "Main Pool", value: "Main Pool" },
    { label: "Marble Floors", value: "Marble Floors" },
    { label: "Next to Busy Way", value: "Next to Busy Way" },
    { label: "Outdoor Gym", value: "Outdoor Gym" },
    { label: "Parking", value: "Parking" },
    { label: "Patio Seating", value: "Patio Seating" },
    { label: "Pool Patio", value: "Pool Patio" },
    { label: "Seating Area", value: "Seating Area" },
    { label: "Shared Gym", value: "Shared Gym" },
    { label: "Shared Pool", value: "Shared Pool" },
    { label: "Sunken Lawn", value: "Sunken Lawn" },
    { label: "Swimming Pool", value: "Swimming Pool" },
    { label: "Tennis Court", value: "Tennis Court" },
    { label: "View of Water", value: "View of Water" },
    { label: "Built in wardrobes", value: "Built in wardrobes" },
    { label: "Central air conditioning", value: "Central air conditioning" },
    { label: "Concierge Service", value: "Concierge Service" },
    { label: "Covered parking", value: "Covered parking" },
    { label: "Fully fitted kitchen", value: "Fully fitted kitchen" },
    { label: "Jacuzzi", value: "Jacuzzi" },
    { label: "Kitchen Appliances", value: "Kitchen Appliances" },
    { label: "Maid Service", value: "Maid Service" },
    { label: "Maid's room", value: "Maid's room" },
    { label: "Maids Room", value: "Maids Room" },
    { label: "Pets allowed", value: "Pets allowed" },
    { label: "Private garden", value: "Private garden" },
    { label: "Private Gym", value: "Private Gym" },
    { label: "Private swimming pool", value: "Private swimming pool" },
    { label: "Security", value: "Security" },
    { label: "Shared swimming pool", value: "Shared swimming pool" },
    { label: "Spa", value: "Spa" },
    { label: "Study", value: "Study" },
    { label: "view of landmark", value: "view of landmark" },
    { label: "View of sea/water", value: "View of sea/water" },
    { label: "Walk-in Closet", value: "Walk-in Closet" },
  ];

  return (
    <div className="video-url-container">
      {/* additionalDetails */}
      <h4 style={{ paddingBottom: "10px" }}>Additional Details</h4>
      <Form.List name="additionalDetails">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <Space
                key={key}
                style={{ display: "flex", marginBottom: 8 }}
                align="baseline"
              >
                <Form.Item
                  {...restField}
                  name={[name, "title"]}
                  label="Title"
                  rules={[{ required: false, message: "Missing Title" }]}
                >
                  <Input placeholder="" />
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, "value"]}
                  label="Virtual Tour Video URL"
                  rules={[{ required: false, message: "Missing value" }]}
                >
                  <Input placeholder="" />
                </Form.Item>
                <MinusCircleOutlined onClick={() => remove(name)} />
              </Space>
            ))}
            <Form.Item>
              <Button
                type="dashed"
                onClick={() => add()}
                block
                icon={<PlusOutlined />}
              >
                Add field
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
      {/* Features */}
      <h4 style={{ paddingBottom: "10px" }}>Features</h4>
      <div style={{ background: "#f8f8f8", padding: "25px" }}>
        <Form.Item
          name="features"
          label=""
          rules={[{ required: false, message: "This field is required" }]}
        >
          <Checkbox.Group options={options} />
        </Form.Item>
      </div>
      {/* Property */}
      <h4 style={{ padding: "20px 0px 10px 0px" }}>Property Label Text</h4>
      <span
        style={{
          color: "#949494",
          fontSize: "13px",
          margin: "0px 0px 0px 0px",
        }}
      >
        You can add a property label to display on property thumbnails. Example:
        Hot Deal
      </span>
      <Form.Item
        name="propertyLabel"
        rules={[{ required: false, message: "This field is required" }]}
      >
        <Input placeholder="" />
      </Form.Item>
      {/* Label Background Color */}
      {/* <h4 style={{ paddingBottom: "10px" }}>Label Background Color</h4>
      <Form.Item
        name="labelBackgroundColor"
        label=""
        rules={[{ required: false, message: "This field is required" }]}
      >
        <ColorPicker defaultValue="#1677ff" />
        <div style={{ color: "#949494", fontSize: "13px", marginTop: "5px" }}>
          Set a label background color. Otherwise label text will be displayed
          with blue background.
        </div>
      </Form.Item> */}
    </div>
  );
};

export default Map;
